export enum OpportunitySystemStage {
    Open = 'Open',
    Closed = 'Closed'
}

export const OpportunitySystemStages = Object.values(OpportunitySystemStage);

export enum OpportunityStageSystemName {
    OpenNew = 'New',
    ClosedWon = 'Won',
    ClosedLost = 'Lost'
}
